// ── 정산 위젯 (Mini Row, 2026-06-06 정리) ────────────────────────────────────
// 사용자 결정: 합산 위젯(my_settlement_owed) 제거. 회사별 3개 위젯으로 분리.
//   my_settlement_owed_pine  - 파인 정산 받을돈
//   my_settlement_owed_dot   - DOT 정산 받을돈
//   my_settlement_owed_lnj   - LNJ 정산 받을돈
// 큰 금액 → formatCompactKrw 로 단위 축약.

import React from 'react';
import { Wallet, Coins } from 'lucide-react';
import { cn } from '../../../../lib/utils';
import { MiniRow } from './MiniRow';
import { formatCompactKrw } from '../widgetFormat';

// 본인 정산 — 회사명 작게 상단 + 큰 금액 (text-2xl font-black accent) + "원" 작게.
// watermark: Coins.
function CompanyOwedMini({ data, labelText, accentOverride, sortableId, onClick }) {
  if (!data) return <MiniRow icon={Wallet} label={labelText} accent="amber" accentOverride={accentOverride} size="S" loading sortableId={sortableId} watermarkIcon={Coins} onClick={onClick} />;
  if (!data.allowed) return <MiniRow icon={Wallet} label={labelText} accent="amber" accentOverride={accentOverride} size="S" denied sortableId={sortableId} watermarkIcon={Coins} />;
  const amount = Number(data.amount || 0);
  const amountColor = amount > 0
    ? 'text-amber-700 dark:text-amber-300'
    : amount < 0 ? 'text-red-600 dark:text-red-400' : 'text-[var(--text-muted)]';
  // formatCompactKrw 결과는 "N,NNN원" 형식 — 금액 + 원 단위 분리해 강조.
  const formatted = formatCompactKrw(amount);
  const isWonSuffix = formatted.endsWith('원');
  const amountText = isWonSuffix ? formatted.slice(0, -1) : formatted;
  return (
    <MiniRow icon={Wallet} label={labelText} accent="amber" accentOverride={accentOverride} width="wide" size="S" sortableId={sortableId} watermarkIcon={Coins} onClick={onClick}>
      <span className="inline-flex items-baseline gap-1 whitespace-nowrap max-w-full">
        <span className={cn('text-xl font-black tabular-nums leading-none whitespace-nowrap', amountColor)}>
          {amountText}
        </span>
        {isWonSuffix && (
          <span className="text-[11px] font-semibold text-[var(--text-sub)] whitespace-nowrap">원</span>
        )}
      </span>
    </MiniRow>
  );
}

export function MySettlementOwedPineMini({ data, accentOverride, sortableId, onClick }) {
  return <CompanyOwedMini data={data} labelText="받을돈(PINE)" accentOverride={accentOverride} sortableId={sortableId} onClick={onClick} />;
}

export function MySettlementOwedDotMini({ data, accentOverride, sortableId, onClick }) {
  return <CompanyOwedMini data={data} labelText="받을돈(DOT)" accentOverride={accentOverride} sortableId={sortableId} onClick={onClick} />;
}

export function MySettlementOwedLnjMini({ data, accentOverride, sortableId, onClick }) {
  return <CompanyOwedMini data={data} labelText="받을돈(LNJ)" accentOverride={accentOverride} sortableId={sortableId} onClick={onClick} />;
}
